import { createShallowStore } from "replo-utils/react/zustand";

interface AdminPanelStore {
  isVisible: boolean;
  actions: {
    open: () => void;
    close: () => void;
    toggle: () => void;
  };
}

export const useAdminPanelStore = createShallowStore<AdminPanelStore>(
  (set) => ({
    isVisible: false,
    actions: {
      open: () => set({ isVisible: true }),
      close: () => set({ isVisible: false }),
      toggle: () => set((state) => ({ isVisible: !state.isVisible })),
    },
  }),
);

export const useAdminPanelActions = () => {
  return useAdminPanelStore((state) => state.actions);
};
